import { initializeApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyCXt2A8-s1MgHHOvp3rlQ5bxudFUaSYGNg",
    authDomain: "react-termin-app.firebaseapp.com",
    projectId: "react-termin-app",
    storageBucket: "react-termin-app.firebasestorage.app",
    messagingSenderId: "619282926259",
    appId: "1:619282926259:web:c8786fa40a6214da31bec6"
  };

const app = initializeApp(firebaseConfig);
export const functions = getFunctions(app);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
